module.exports = __webpack_public_path__ + "static/Profile-c855aeafc3f2a9f313b25087f35a022c.png";